import {
    destroyDiscoverMobileLeadInCarousel,
    initDiscoverMobileLeadInCarousel,
} from '../components/DiscoverLeadInCarousel';

document.addEventListener('DOMContentLoaded', () => {
    initDiscoverMobileLeadInCarousel();    
});

function handleResize(): void {
    destroyDiscoverMobileLeadInCarousel();
    initDiscoverMobileLeadInCarousel();
}

window.addEventListener('resize', handleResize, { passive: true });